module.exports = __webpack_public_path__ + "static/media/referral-program-2.b4b36d02.jpg";